import type { Movie } from '@/mocks/movies';
import { Link } from 'react-router-dom';

interface MovieCardProps {
  movie: Movie;
  size?: 'sm' | 'md' | 'lg';
}

export default function MovieCard({ movie, size = 'md' }: MovieCardProps) {
  const posterWidth = size === 'lg' ? 300 : size === 'md' ? 220 : 160;
  const posterHeight = size === 'lg' ? 420 : size === 'md' ? 310 : 225;

  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div
        className="relative overflow-hidden rounded-lg"
        style={{ width: posterWidth, height: posterHeight }}
      >
        <img
          src={movie.posterUrl}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 七七影院高清在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 right-2 bg-primary-500 text-white text-xs font-semibold px-2 py-1 rounded-md">
          {movie.rating}
        </div>
        {movie.type === 'tv' && (
          <div className="absolute top-2 left-2 bg-accent-500 text-white text-xs font-semibold px-2 py-1 rounded-md">
            电视剧
          </div>
        )}
        {movie.isNew && (
          <div className="absolute bottom-2 left-2 bg-accent-500 text-white text-xs font-semibold px-2 py-1 rounded-md">
            最新
          </div>
        )}
      </div>
      <div className="mt-2 px-1">
        <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors" style={{ fontFamily: 'var(--font-body)' }}>
          {movie.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-0.5">
          {movie.year} · {movie.rating}分
        </p>
      </div>
    </Link>
  );
}